import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Typography, Divider } from '@mui/material';
import { TextInput, PasswordInput } from '../../../components/TextFields';
import { useAlert } from '../../../components/Notification';
import { hashPassword } from '../../../constant/constant';

import { handlePasswordReset } from '../../../stores/services/authApis/index';

interface ResetProps {
  email: string;
}

const ResetPassword: React.FC<ResetProps> = ({ email }) => {
  const navigate = useNavigate();
  const showAlert = useAlert();
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isOtpValid, setisOtpValid] = useState(false);
  const [isPasswordValid, setisPasswordValid] = useState(false);
  const [isConfirmPasswordValid, setisConfirmPasswordValid] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState<any>({
    password: false,
    confirmPassword: false,
  });
  const [otpErrorMessage, setOtpErrorMessage] = useState(false);

  const Reset = async () => {
    await handlePasswordReset({
      userEmail: email,
      resetInfo: {
        otp: otp ? Number(otp) : otp,
        password: hashPassword(password),
      },
    })
      .then(() => {
        showAlert('Password reset Successfully', 'success');
        navigate('/login');
      })
      .catch(() => {
        showAlert('Invalid OTP', 'error');
      });
  };

  const onEnetrKeyPress = () => {
    if (isOtpValid && isPasswordValid && isConfirmPasswordValid) {
      Reset();
    } else {
      validation();
    }
  };

  const validation = () => {
    if (
      confirmPassword?.trim()?.length === 0 &&
      password?.trim()?.length === 0
    ) {
      setLoginErrorMessage({ confirmPassword: true, password: true });
    } else if (confirmPassword?.trim()?.length === 0) {
      setLoginErrorMessage({ confirmPassword: true, password: false });
    } else if (password?.trim()?.length === 0) {
      setLoginErrorMessage({ confirmPassword: false, password: true });
    }

    if (otp?.trim()?.length === 0) {
      setOtpErrorMessage(true);
    }
  };

  const handleChangePassword = (value: React.SetStateAction<string>) => {
    setPassword(value);
    setLoginErrorMessage((prev: any) => {
      return { ...prev, password: false };
    });
  };

  const handleChangeConfirmPassword = (value: React.SetStateAction<string>) => {
    setConfirmPassword(value);
    setLoginErrorMessage((prev: any) => {
      return { ...prev, confirmPassword: false };
    });
  };

  const handleChangeOtp = (value: React.SetStateAction<string>) => {
    setOtp(value);
    setOtpErrorMessage(false);
  };

  return (
    <>
      <div className="form_header">
        <Typography variant="h5" align="center" fontWeight="bold">
          OTP
        </Typography>
        <Typography align="center" variant="body2">
          <p className="form-instructions">
            A digit code has been sent to your
          </p>
        </Typography>
        <Typography align="center" variant="body2">
          <p className="form-instructions routerLink">{email}</p>
        </Typography>
      </div>
      <div className="auth_form">
        <div className="auth_formitem">
          <div className="form-input">
            <PasswordInput
              value={password}
              handleValid={setisPasswordValid}
              onChange={handleChangePassword}
              error={isPasswordValid}
              onKeyDown={onEnetrKeyPress}
              errormessage={loginErrorMessage?.password}
            />
          </div>

          <div className="form-input">
            <PasswordInput
              label="Confirm Password"
              value={confirmPassword}
              handleValid={setisConfirmPasswordValid}
              onChange={handleChangeConfirmPassword}
              error={isConfirmPasswordValid}
              onKeyDown={onEnetrKeyPress}
              errormessage={loginErrorMessage?.confirmPassword}
            />
          </div>
          <div className="form-input">
            <TextInput
              name="otp"
              id="otp"
              label="Enter OTP"
              type="number"
              required={true}
              placeholder="Ex 179452"
              value={otp}
              handleValid={setisOtpValid}
              onChange={handleChangeOtp}
              error={isOtpValid}
              minLength={4}
              maxLength={6}
              onKeyDown={onEnetrKeyPress}
              errormessage={otpErrorMessage}
            />
          </div>
        </div>
        <Divider component="div" role="presentation" />
        <div className="auth_formitem">
          <button
            className="submit_Button"
            disabled={
              !(isOtpValid && isPasswordValid && isConfirmPasswordValid)
            }
            color="primary"
            onClick={() => {
              Reset();
            }}
          >
            Reset Your Password
          </button>
          <Typography
            variant="body2"
            align="center"
            className="submit_Button-text"
          >
            Don&apos;t remember you email? <br />
            <RouterLink className="routerLink" to="/forgot-password">
              Contact Support
            </RouterLink>
          </Typography>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
